import { memo, useEffect } from 'react';

import { PDF_SECTIONS } from 'PDF/constants/sections';
import { prepareSectionId } from 'PDF/helpers/pdfMapping';
import { IPdfPageProps } from 'PDF/types/pdf';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters, getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { getProductAndServicesProps } from './mappings';

export const ProductsAndServices = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const { isExamplePage } = useExamplePreview();
  const { data, magazineItems } = getProductAndServicesProps(businessPlanChapters, isExamplePage);

  useEffect(() => {
    if (sectionPicture) {
      saveSectionProps(prepareSectionId(businessPlanType, PDF_SECTIONS.PRODUCT_AND_SERVICES), {
        magazineItems,
        data,
      });
    }
  }, [sectionPicture]);

  return null;
})
